var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_9713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0365 10.8197C14.0365 10.7988 13.5752 7.75852 13.4284 6.83596C13.2188 5.47309 12.1285 4.71875 10.7656 4.71875H9.23499C7.87213 4.71875 6.76087 5.47309 6.57216 6.83596C6.42538 7.75852 5.9641 10.7778 5.9641 10.8197C5.9012 11.2181 6.17378 11.5955 6.57216 11.6584H6.67699C7.03344 11.6584 7.34795 11.4068 7.38988 11.0504C7.38988 11.0333 7.69493 9.01958 7.88783 7.77175C7.89936 7.69712 8.00905 7.70535 8.01036 7.78086L8.08181 11.889L7.64198 18.4718C7.60004 18.996 7.97745 19.4572 8.50163 19.4992C9.02581 19.5411 9.48709 19.1637 9.52903 18.6395L9.9479 11.7833H10.0108L10.4297 18.6395C10.4716 19.1218 10.8909 19.4992 11.3732 19.4992H11.4571C11.9812 19.4573 12.3586 18.996 12.3167 18.4718L11.8769 11.889L11.9481 7.77515C11.9494 7.69957 12.0591 7.69048 12.0705 7.76521C12.2457 8.91383 12.5688 11.0351 12.5688 11.0503C12.6317 11.4068 12.9253 11.6584 13.2817 11.6584H13.3865C13.8268 11.5745 14.0994 11.2181 14.0365 10.8197Z",
    fill: "url(#paint0_linear_383_9713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98956 4.192C11.0091 4.192 11.8356 3.36552 11.8356 2.346C11.8356 1.32648 11.0091 0.5 9.98956 0.5C8.97004 0.5 8.14355 1.32648 8.14355 2.346C8.14355 3.36552 8.97004 4.192 9.98956 4.192Z",
    fill: "url(#paint1_linear_383_9713)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_9713",
    x1: 5.95508,
    y1: 12.1106,
    x2: 14.0455,
    y2: 12.1106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_9713",
    x1: 8.14355,
    y1: 2.346,
    x2: 11.8356,
    y2: 2.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_9713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.79d47056d3d8a95a9e5b661c74c7af23.svg";
export { ForwardRef as ReactComponent };